module.exports = __webpack_public_path__ + "img/auth-back.0c1f5438.jpg";